import { render, staticRenderFns } from "./partnerInfoBox.vue?vue&type=template&id=720ac43c&"
import script from "./partnerInfoBox.vue?vue&type=script&lang=ts&"
export * from "./partnerInfoBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports